/* eslint-disable no-undef */
import { Controller } from '@hotwired/stimulus';

export default class AdsController extends Controller {
  connect() {
    window.addEventListener('turbolinks:render', this.turbolinksInitAds);
    window.addEventListener('turbolinks:before-visit', this.resetAds);
  }

  disconnect() {
    window.removeEventListener('turbolinks:render', this.turbolinksInitAds);
    window.removeEventListener('turbolinks:before-visit', this.resetAds);
  }

  turbolinksInitAds = () => {
    this.adsScriptLoaded = false;

    this.initAds();
  }

  initAds = () => {
    const properAdsScriptCheck = setInterval(() => {
      if (this.properSpaNewPageReady && !this.adsScriptLoaded) {
        properSpaNewPage(); /* eslint-disable-line no-undef */

        this.adsScriptLoaded = true;
      }

      if (this.properSpaNewPageReady) {
        clearInterval(properAdsScriptCheck);
      }
    }, 100);
  }

  get properSpaNewPageReady() {
    if (typeof window.properSpaNewPage === 'undefined') return false;

    return true;
  }

  resetAds = () => {
    this.disconnect();

    this.connect();
  }
}
/* eslint-enable no-undef */
